import { render } from "./mhead&mlogin.vue?vue&type=template&id=08cadb06&scoped=true&bindings={\"showlogin\":\"data\",\"closeeye\":\"data\",\"openeye\":\"data\",\"changeeye\":\"data\",\"passwordtype\":\"data\",\"username\":\"data\",\"password\":\"data\",\"ctrlMenu\":\"data\",\"logo\":\"data\",\"clickImg\":\"data\",\"nav\":\"data\",\"changeTop\":\"props\",\"closeTop\":\"props\",\"showMenu\":\"options\",\"gogogo\":\"options\",\"login\":\"options\"}"
import script from "./mhead&mlogin.vue?vue&type=script&lang=js"
export * from "./mhead&mlogin.vue?vue&type=script&lang=js"

import "./mhead&mlogin.vue?vue&type=style&index=0&id=08cadb06&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-08cadb06"

export default script